$(document).ready(function() {
  $('.contact-trigger').on('click', function(evt) {
    evt.preventDefault();
    $('#contact-modal').addClass('open');
    $('body').addClass('overflow-hidden');
    $('#navigation-modal').removeClass('open');
    return false;
  });

  $('.close-contact-modal').on('click', function(evt) {
    evt.preventDefault();
    $('#contact-modal').removeClass('open');
    $('body').removeClass('overflow-hidden');
    return false;
  })
});


